import { STANDARD_PALETTES } from '@/app/core/auto-generated/standard-palettes';
import type { TonalPalette } from './palette';

export type ThemePalette = Pick<TonalPalette, 'colors' | 'hue'>;

/** The same palette read API without importing the color-generation libraries. */
class PrecomputedPalette implements ThemePalette {
  constructor(private readonly palette: ReturnType<TonalPalette['colors']>) {}

  colors(): ReturnType<TonalPalette['colors']> {
    return this.palette;
  }

  hue(value: number, format: 'hex' | 'oklch' = 'oklch'): string | null {
    const color = this.palette.find((entry) => entry.hue === value);
    return color ? color[format] : null;
  }
}

export function precomputedPalette(color: string): ThemePalette | undefined {
  const colors = STANDARD_PALETTES[color.trim().toUpperCase()];
  return colors
    ? new PrecomputedPalette(colors.map((entry) => ({ ...entry })))
    : undefined;
}
